import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Link/sgds-link";
import { register } from "../../utils/ce-registry";

register("sgds-link", Component);

export default createComponent({
  react: React,
  tagName: "sgds-link",
  elementClass: Component,
  events: {}
});
